import React, { Component } from 'react'
import DropzoneComponent from 'react-dropzone-component';

////import store from "../../helpers/store"
////import { updateDirectUploadState } from "../../actions/appActions"

var myDropzone;
// const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
var componentConfig;
var eventHandlers;
var djsConfig = { autoProcessQueue: true, addRemoveLinks: true }
var uploadfolder = "NIC003" // MOVE THIS TO PROPS LATER

var s3Bucket = "coreprintdamlive";
if (document.location.href.toLowerCase().indexOf("test-aspire") != -1 ) {
  s3Bucket = "coreprintdamtest";
} else if (document.location.href.toLowerCase().indexOf("fester") != -1 ) {
  s3Bucket = "coreprintdamgolf";
} else if (document.location.href.toLowerCase().indexOf("http://192.168.1.71") != -1 ) {
  s3Bucket = "coreprintdamgolf";
}

export default class Dropzone extends Component {
    constructor(props) {
        super(props);
        var tempUploadProgress = 0
        var lastUploadTimestamp
        this.state = {uploadProgress: 0, uploadProgressLabel: 'Upload files', showUploader:false};

        componentConfig = {
            iconFiletypes: ['.jpg', '.png', '.gif'],
            showFiletypeIcon: true,
            //dropzoneSelector: '.folderView__inner',
            maxFilesize: 1000,
            timeout: 0,
            //postUrl: 'https://uploader.coreprint.net/upload2.php?bucket='+s3Bucket+'&folder='+this.props.uploadfolder
            // postUrl: 'https://services.coreprint.net/uploader/upload2.php?bucket='+s3Bucket+'&folder='+this.props.uploadfolder
            postUrl: 'https://services.coreprint.net/uploader/upload2.php?bucket='+s3Bucket+'&folder='+uploadfolder

        };

        console.log("s3Bucket: ", s3Bucket)
        console.log("this.props.uploadfolder: ", this.props.uploadfolder)

        eventHandlers = { 
            init: (dropzoneInstance) => {
                myDropzone = dropzoneInstance;
            },
            addedfile: (file) => {
                console.log(file)
                this.setState({
                //showUploader: true,
                //uploadProgressLabel: this.props.uploading
                });
            },
            success: (file, json) => {
                myDropzone.removeFile(file);
                // let jsonObject = JSON.parse(json); // Adding dam item
                // jsonObject['checksum'] = 12345678910;
                // jsonObject['folderid'] = this.props.selectedFolder.id;
                //console.log("Returned json from uploader: ", json)
                let parsedJSON = JSON.parse(json)
                let s3Key = parsedJSON.s3Key
                //console.log("s3Key: ", s3Key)
                let resultURL = "https://" + s3Bucket + ".s3-eu-west-1.amazonaws.com/" + uploadfolder + "/" + s3Key
                // resultURL should look like this: https://coreprintdamlive.s3-eu-west-1.amazonaws.com/NIC003/5e21d6240fb4c
                
                this.props.setloadedImage(resultURL)
            },
            maxfilesexceeded: () => {
                console.log('File too big');
            },
            error: () => {
                console.log('Upload error')
            },
            totaluploadprogress: (progress) => {
                console.log('uploadProgress', progress.toFixed(2))
                this.tempUploadProgress = progress
            }
        }
    }



 componentDidMount() {

        

    }


    // closeDropzone = () => {
    //     store.dispatch(updateDropzoneState(false));
    // }

    /* Displays an error message alert if the upload gets stuck */
    checkUploadProgress = (p) => {
        //console.log("Running checkUploadProgress")
        //console.log("p1: ", p)
        //console.log("this.tempUploadProgress1: ", this.tempUploadProgress)
        setTimeout(function(){ 
            //console.log("10 sec has passed")
            //console.log("p2: ", p)
            //console.log("this.tempUploadProgress2: ", this.tempUploadProgress)
            //console.log("this.lastUploadTimestamp: ", this.lastUploadTimestamp)
            var now = Date.now()
            //console.log("now: ", now)
            if (now - this.lastUploadTimestamp > 60000) {
                //console.log("1 min has passed between now and lastUploadTimestamp ")
                
                if (this.tempUploadProgress < 100) {
                    //console.log("tempUploadProgress is < 100")
                    alert('Your upload has timed out, please try again.')
                }
            }
        }.bind(this), 60000);
    }

    _handleSimulateClick = (e) => {
        var evt;
        var el = document.getElementsByClassName('dz-hidden-input')[0];
        if (document.createEvent) {
            evt = document.createEvent("MouseEvents");
            evt.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        }
        (evt) ? el.dispatchEvent(evt) : (el.click && el.click());
    }


    hoverOn = (e) => {
        console.log('hoverOn');
        //this.setState({ hover: true });
        //store.dispatch(updateShowDropzoneState(true));
    }

    hoverOff = (e) => {
        console.log('hoverOff');
        //this.setState({ hover: false });    
       // store.dispatch(updateShowDropzoneState(false));
    }


    componentWillMount() {
    }

    componentWillReceiveProps(nextProps) {
        /*if (this.props.selectedFolder.id !== nextProps.selectedFolder.id) {
        this.fetchDamItems(nextProps.selectedFolder.id);
        }*/
    }

    render() {
        return <React.Fragment>
            <DropzoneComponent config={componentConfig} eventHandlers={eventHandlers} djsConfig={djsConfig} /> 
        </React.Fragment>
    }
}
